import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canAccessBulkUpdate, resolvePulseRoleName, isTruthyRoleFlag } from './utils/bulk-upload-access';

/** Super Admin / Administrator — bulk metadata update via ISRC/UPC. */
export const bulkUpdateGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (!localStorage.getItem('access_token')) {
    router.navigate(['login']);
    return false;
  }

  const roleDetailRaw = localStorage.getItem('role_detail');
  let roleDetail: any = null;
  try {
    roleDetail = roleDetailRaw ? JSON.parse(roleDetailRaw) : null;
  } catch {
    roleDetail = null;
  }

  const url = String(state.url || '');
  const flagAllowed = isTruthyRoleFlag(roleDetail?.is_bulk_update_visible);

  const anyFlagPresent = roleDetail?.is_bulk_update_visible != null;
  const roleName = resolvePulseRoleName();
  const legacyAllowed = canAccessBulkUpdate(roleName);

  const allowed = anyFlagPresent ? flagAllowed : legacyAllowed;
  if (!allowed) {
    router.navigate(['home']);
    return false;
  }
  return true;
};
